// Module
var code = "<react-component name=\"MobileAppUsersReport\"></react-component>\n";
// Exports
module.exports = code;